const i18nConfig = {
  locales: ['en', 'de', 'uk'],
  defaultLocale: 'en'
};

export default i18nConfig;